import CubemapUtil from 'lib/helpers/cubemap.util';
import Pannellum from 'lib/pannellum';
import FloorplanManager from 'lib/service/e3.plan.manager';
import { getPolygonBounding } from 'a_common-folder/utils/geometry';
import { generateUUID } from 'lib/helpers/common';

export default class RenderZoneManager {
    _vertices = [];
    _zones = [];

    addPoint(spherCoord) {
        const sphere = spherCoord.map(v => v * Pannellum.RADIAN);
        this._vertices.push({
            sphere,
            floorCube: CubemapUtil.getBoxCoords(...sphere),
        });
    }

    getVertexCount() {
        return this._vertices.length;
    }

    getVerticesSpherCoords() {
        return this._vertices.map(d => [d.sphere]);
    }

    getBoundingCoordCount() {
        return this._zones.length;
    }

    getBoundingCoordVerticesSpherCoords() {
        return this._zones.map(({ bountingCoord, uuid }) => ({ bountingCoord, uuid }));
    }

    getCubeVertices() {
        return {
            hasGhostPoint: !!this._ghostCubeCoord,
            finished: false,
            points: [
                ...this._vertices.map(d => [d.floorCube]),
                ...(this._ghostCubeCoord ? [this._ghostCubeCoord.coords] : []),
            ],
            rectanglePoints: this._zones,
        };
    }

    pushToZone(uuid) {
        const sphereCoords = this._vertices.map(d => d.sphere);
        const { maxX, maxY } = getPolygonBounding(sphereCoords);
        const zone = {
            uuid,
            url: '',
            type: 'video',
            sphereCoords,
            points: this._vertices.map(d => [d.floorCube]),
            bountingCoord: [[FloorplanManager.normalizeYaw(maxX), maxY]],
            finished: true,
        };
        this._zones.push(zone);
        this._vertices = [];
        return zone;
    }

    setZoneMedia(uuid, url, type) {
        const zone = this._zones.find(z => z.uuid === uuid);
        if (zone) { zone.url = url; zone.type = type || 'video'; }
    }

    countZones() {
        return this._zones.length;
    }

    getZones() {
        return this._zones;
    }

    getZonesForSave() {
        return this._zones.map(({ uuid, url, type, sphereCoords }) => ({ uuid, url, type: type || 'video', sphereCoords }));
    }

    removeZone(uuid) {
        this._zones = this._zones.filter(z => z.uuid !== uuid);
    }

    removeCurrentArea() {
        this._vertices = [];
    }

    setZones(zones) {
        this._zones = zones.map(({ uuid, url, type, sphereCoords }) => {
            const { maxX, maxY } = getPolygonBounding(sphereCoords);
            return {
                uuid: uuid || generateUUID(),
                url: url || '',
                type: type || 'video',
                sphereCoords,
                points: sphereCoords.map(c => [CubemapUtil.getBoxCoords(...c)]),
                bountingCoord: [[FloorplanManager.normalizeYaw(maxX), maxY]],
                finished: true,
            };
        });
    }

    setGhostPoint(coord) {
        const pair = [coord.map(c => c * Pannellum.RADIAN)];
        this._ghostCubeCoord = {
            spherCoords: pair,
            coords: [CubemapUtil.getBoxCoords(...pair[0])],
        };
    }

    removeGhostPoint() {
        this._ghostCubeCoord = null;
    }

    destroy() {
        this._vertices = [];
        this._zones = [];
        this._ghostCubeCoord = null;
    }
}
